import { AdminFormPage } from "@zzk/admin";
import { createElement } from "react";
import { Button, FormField, Input, Select, createFieldState } from "@zzk/ui";
import type { SettingsProfile } from "../validators.js";

export const settingsLocaleOptions = [
  { value: "pt-BR", label: "Português (Brasil)" },
  { value: "en-US", label: "English (US)" },
] as const;

export function createSettingsProfileState(profile: SettingsProfile) {
  return {
    fields: {
      displayName: createFieldState({
        name: "displayName",
        label: "Display name",
        value: profile.displayName,
        required: true,
      }),
      locale: createFieldState({
        name: "locale",
        label: "Locale",
        value: profile.locale,
        required: true,
      }),
    },
    profile,
  };
}

export function createSettingsProfileView(profile: SettingsProfile) {
  const state = createSettingsProfileState(profile);

  return AdminFormPage({
    title: "My profile",
    description: "Personal display name and interface locale.",
    children: createElement(
      "div",
      { className: "grid gap-4", "data-zzk-settings-profile-fields": true },
      FormField({
        name: state.fields.displayName.name,
        label: state.fields.displayName.label,
        required: state.fields.displayName.required,
        control: Input({ defaultValue: state.fields.displayName.value }),
      }),
      FormField({
        name: state.fields.locale.name,
        label: state.fields.locale.label,
        required: state.fields.locale.required,
        control: Select({
          defaultValue: state.fields.locale.value,
          options: settingsLocaleOptions.map((option) => ({
            value: option.value,
            label: option.label,
          })),
        }),
      }),
    ),
    actions: Button({ type: "submit", children: "Save profile" }),
  });
}
